import * as React from 'react';
import { CharacteristicGroup, Characteristic, CharacteristicGroupCharacteristic, CharacteristicGroupSubGroup, CharacteristicGroupSubGroupCharacteristic } from '../../../models';
import { FilterStore } from '../../../stores';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import { PVASelect } from './PVASelect';
import './PVASelect.css';

interface PVASelectProps {
    groups: CharacteristicGroup[];
    options: Characteristic[];
    selected: number | undefined;
    onChange: Function;
    FilterStore?: FilterStore;
    responseIndicator?: boolean;
    showAll?: boolean;
    disabled?: boolean;
}


@inject('FilterStore') @observer
export class PVACharacteristicSelect extends React.Component<PVASelectProps> {
    @computed get survey() {
        if (this.props.FilterStore && this.props.FilterStore.survey) {
            return this.props.FilterStore.survey;
        }
        return null;
    }

    @computed get surveyVersion() {
        if (this.props.FilterStore && this.props.FilterStore.surveyVersion) {
            return this.props.FilterStore.surveyVersion;
        }
        return null;
    }

    @computed get surveyReportType() {
        if (this.props.FilterStore && this.props.FilterStore.surveyReportType) {
            return this.props.FilterStore.surveyReportType;
        }
        return null;
    }

    private selectedCharacteristic() {
        if (!this.props.selected) {
            return null;
        }
        
        var char = this.props.options.find((c: Characteristic) => {
            return c.id === this.props.selected;
        });
        if (char) {
            return char;
        }
        return undefined;
    }

    private characteristicChange(characteristic?: Characteristic) {
        if (characteristic === undefined) {
            return;
        }
        if (this.props.onChange) {
            this.props.onChange({
                target: {
                    value: characteristic.id
                }
            });
        }
    }

    simpleSort(a: any, b: any) {
        if (a.sort > b.sort) {
            return 1;
        }
        if (a.sort < b.sort) {
            return -1;
        }
        return 0;
    }

    characteristicGroupCharacteristicSort(a: CharacteristicGroupCharacteristic, b: CharacteristicGroupCharacteristic) {
        if (a.sort > b.sort) {
            return 1;
        }
        if (a.sort < b.sort) {
            return -1;
        }
        if (a.characteristic && b.characteristic) {
            if (a.characteristic.sort > b.characteristic.sort) {
                return 1;
            }
            if (a.characteristic.sort < b.characteristic.sort) {
                return -1;
            }
        }
        return 0;
    }

    getCharacteristic(cId: number) {
        return this.props.options.find(x => x.id === cId);
    }
    
    renderOptions = () => {
        var offset = 0;
        return (
            <React.Fragment>
                {
                    this.props.groups
                        .filter((group: CharacteristicGroup) => {
                            if (!this.props.showAll) {
                                if (this.props.responseIndicator && group.characteristicGroupDisplayType !== 'responseIndicator') {
                                    return false;
                                }

                                if (!this.props.responseIndicator && group.characteristicGroupDisplayType === 'responseIndicator') {
                                    return false;
                                }
                            }
                            var count = 0;
                            if (group.characteristics) {
                                count += group.characteristics.length;
                            }
                            if (group.characteristicGroupCharacteristics) {
                                count += group.characteristicGroupCharacteristics.length;
                            }
                            if (group.characteristicGroupSubGroups) {
                                count += group.characteristicGroupSubGroups.length;
                            }

                            if (count === 0) {
                                return false;
                            }
                            if (group.secondaryReportID) {
                                return false;
                            }
                            if (this.props.showAll) {
                                return true;
                            }
                            if (!this.surveyReportType || !group.surveyReportTypeID) {
                                return false;
                            }

                            return group.surveyReportTypeID === this.surveyReportType.id;
                        })
                        .map((group: CharacteristicGroup, index: number) => {
                            var off = offset;
                            offset += group.characteristics.length + group.characteristicGroupCharacteristics.length;

                            return <div key={`select-opt-${group.id}-${index}`}>
                                <div className="title-header">{group.name}</div>
                                {this.props.showAll && <div className="title-header-sub"><small>{group.surveyReportType ? group.surveyReportType.name : ''}</small></div>}
                                {
                                    group.characteristicGroupCharacteristics && group.characteristicGroupCharacteristics.sort(this.characteristicGroupCharacteristicSort).map((c: CharacteristicGroupCharacteristic, ind: number) => {
                                        return <div className="option" onClick={(e) => c.characteristic && this.characteristicChange(c.characteristic)} key={`characteristic-${c.characteristic && c.characteristic.id}`}> {off + ind + 1}. {c.characteristic && (c.characteristic.displayName ? c.characteristic.displayName : c.characteristic.name)}</div>;
                                    })
                                }
                                {
                                    group.characteristicGroupSubGroups && group.characteristicGroupSubGroups.sort(this.simpleSort).map((cgsg: CharacteristicGroupSubGroup, subGroupInd: number) => {
                                        var tempOff = off;
                                        off += cgsg.characteristicGroupSubGroupCharacteristics.length;
                                        offset += cgsg.characteristicGroupSubGroupCharacteristics.length;
                                        return <React.Fragment key={`sub-group-${subGroupInd}`}>
                                            {cgsg.characteristicGroupSubGroupCharacteristics.map((cgsbc: CharacteristicGroupSubGroupCharacteristic, ind: number) => {
                                                var c = this.getCharacteristic(cgsbc.characteristicID);
                                                if (c !== undefined) {
                                                    return <div className="option" onClick={(e) => this.characteristicChange(c)} key={`characteristic-sub-${subGroupInd}-${c.id}`}> {(group.characteristicGroupCharacteristics.length + tempOff) + ind + 1}. {(c.displayName ? c.displayName : c.name)}</div>;
                                                }
                                                return <div className="option" key={`characteristic-sub-${ind}`}>[NOT FOUND]</div>;
                                            })}
                                        </React.Fragment>;
                                    })
                                }
                            </div>;
                        })
                }
            </React.Fragment>
        );
    }

    render() {
        const selected = this.selectedCharacteristic();
        const options = this.props.options.map(o => ({ id: o.id, label: o.name }));

        return (
            <PVASelect
                options={options}
                selected={this.props.selected}
                onChange={this.props.onChange}
                disabled={this.props.disabled}
                noSelectTitle="- Select -"
                stretch={true}
                renderOptions={this.renderOptions}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/blocks/PVACharacteristicSelect.tsx